import * as yup from "yup";
import {yupNumberEmpty} from "../../utils/Utils";


export const lotSchema = yup
    .object({
        productId: yup
            .string()
            .required("E' necessario indicare il prodotto di riferimento del lotto"),
        quantity: yup
            .number()
            .transform((value, originalValue) => originalValue.trim() === "" ? undefined : value),
        expiration: yup
            .string(),
        code: yup
            .string(),
        consumeWithin: yup
            .string(),
        quantityForUnit: yup
            .number()
            .nullable()
            .transform((value, originalValue) => originalValue.trim() === "" ? undefined : value),
        unitMeasurement: yup
            .string(),
        producedOn: yup
            .string(),
        shippingFee: yup
            .number()
            .transform((value, originalValue) => originalValue.trim() === "" ? undefined : value),
        price: yup
            .number()
            .transform((value, originalValue) => originalValue.trim() === "" ? undefined : value),
        discountPrice: yup
            .number()
            .nullable()
            .transform((value, originalValue) => originalValue.trim() === "" ? undefined : value),
        // producerId: yupValueOrUndefined()
    });

export const editLotSchema = yup
    .object({
        productId: yup
            .string(),
        quantity: yupNumberEmpty(),
        expiration: yup
            .string(),
        consumeWithin: yup
            .string(),
        code: yup
            .string(),
        producedOn: yup
            .string(),
        quantityForUnit: yup
            .number()
            .nullable()
            .transform((value, originalValue) => originalValue.trim() === "" ? undefined : value),
        unitMeasurement: yup
            .string(),
        price: yup
            .number()
            .transform((value, originalValue) => originalValue.trim() === "" ? undefined : value),
        shippingFee: yup
            .number()
            .transform((value, originalValue) => originalValue.trim() === "" ? undefined : value),
        discountPrice: yup
            .number()
            .nullable()
            .transform((value, originalValue) => originalValue.trim() === "" ? undefined : value),
        // producerId: yupValueOrUndefined(),
    });

export const billingSchema = yup
    .object({
        productId: yup
            .string()
            .required("E' necessario indicare il prodotto di riferimento del lotto"),
        quantity: yup
            .number()
            .transform((value, originalValue) => originalValue.trim() === "" ? undefined : value),
        expiration: yup
            .string(),
        code: yup
            .string(),
        consumeWithin: yup
            .string(),
        quantityForUnit: yup
            .number()
            .nullable()
            .transform((value, originalValue) => originalValue.trim() === "" ? undefined : value),
        unitMeasurement: yup
            .string(),
        producedOn: yup
            .string(),
        price: yup
            .number()
            .transform((value, originalValue) => originalValue.trim() === "" ? undefined : value),
        discountPrice: yup
            .number()
            .nullable()
            .transform((value, originalValue) => originalValue.trim() === "" ? undefined : value),
        // producerId: yupValueOrUndefined()
    });
